import React from 'react'
import B2bRegistrationComponent from '../Components/B2bRegistration/B2bRegistrationComponent'

function B2bRegistrationPage() {
    return (

        <B2bRegistrationComponent />
    )
}

export default B2bRegistrationPage